import { useTheme } from '@chakra-ui/react';
import { useFormApi } from '@data-driven-forms/react-form-renderer';
import styled from '@emotion/styled';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Box from '~/common/components/Box';
import Button from '~/common/components/Button';

const WrapperDiv = styled<any>(Box)`
  display: grid;
  margin-bottom: 5px;
`;

type ArrayItemProps = {
  fields?: {
    component: string;
    name: string;
    type: string;
    options?: {
      label: string;
      value: string;
    }[];
  }[];
  fieldIndex?: string | number;
  name?: string;
  remove?: (...args: any[]) => any;
  update?: (...args: any[]) => any;
  sx?: any;
  enableIndex?: number;
  valuesToCompare?: any;
  propertyName?: string;
  useConditionalMapper?: boolean;
  value?: any[];
  addRole?: boolean;
  buttonDivSx?: any;
};

export default function ArrayItem({
  fields,
  fieldIndex,
  name,
  remove,
  useConditionalMapper,
  sx,
  addRole,
  value,
  buttonDivSx,
}: Readonly<ArrayItemProps>) {
  const { renderForm } = useFormApi();
  const { colors } = useTheme();

  const editedFields = fields.map((field) => {
    const fieldName = `${name}.${field.name}`;

    if (useConditionalMapper) {
      if (addRole) {
        return {
          ...field,
          name: fieldName,
          role: 'cell',
        };
      } else {
        return {
          ...field,
          name: fieldName,
        };
      }
    }
  });

  return (
    <WrapperDiv
      role={addRole ? 'row' : ''}
      sx={{
        ...sx,
        alignItems: sx.alignItems ? sx.alignItems : 'end',
        gap: sx.gap ? sx.gap : '5px',
      }}
    >
      {renderForm(editedFields)}
      <div role={addRole ? 'cell' : ''} style={{ ...buttonDivSx }}>
        <Button
          isPrimary={true}
          sx={{
            width: '3rem',
            paddingLeft: sx.buttonPaddingLeft ? sx.buttonPaddingLeft : '1rem',
          }}
          backgroundColor={'transparent'}
          aria-label="Delete Button"
          _hover={{ backgroundColor: 'transparent' }}
          _active={{ backgroundColor: 'transparent' }}
          _focus={{ backgroundColor: 'transparent' }}
          isDisabled={value.length === 1}
          onClick={() => {
            remove(fieldIndex);
          }}
        >
          <FontAwesomeIcon icon={faTrash} color={colors?.red[600]} />
        </Button>
      </div>
    </WrapperDiv>
  );
}
